import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationService } from './navigation.service';
import { NavigationInterceptorService } from '../interceptors/navigation-interceptor.service';
import { SmoothNavigationDirective } from '@/app/shared/directives/smooth-navigation.directive';

@NgModule({
  imports: [CommonModule, SmoothNavigationDirective],
  exports: [SmoothNavigationDirective],
  providers: [NavigationService, NavigationInterceptorService],
})
export class NavigationModule {
  /**
   * Use this method in your AppModule to ensure the navigation services are initialized
   */
  static forRoot() {
    return {
      ngModule: NavigationModule,
      providers: [NavigationService, NavigationInterceptorService],
    };
  }
}
